import { createAsyncAction } from '../../utils'; // TODO: import from `~/lib/redux` instead
export const assignTeamZips = createAsyncAction('@@SALES_PLANNING_TOOL/ASSIGN_TEAM_ZIPS');
